import {AfterViewInit, Component} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {MatFormField} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {LoginService} from "./services/login.service";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login-dialog',
  standalone: true,
  imports: [
    MatFormField,
    MatInput,
    FormsModule,
    MatButton,
    NgIf
  ],
  templateUrl: './login-dialog.component.html',
  styleUrl: './login-dialog.component.css'
})
export class LoginDialogComponent implements AfterViewInit{
  username: string = '';
  password: string = '';
  errorMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<LoginDialogComponent>,
    private loginService: LoginService,
    private router: Router
  ) {}
  ngAfterViewInit() {
    // Ajoute la classe 'open' après le rendu initial
    const dialogElement = document.querySelector('.dialog-container');
    if (dialogElement) {
      setTimeout(() => {
        dialogElement.classList.add('open');
      }, 0);
    }
  }

  onLogin(): void {
    this.loginService.login(this.username, this.password).subscribe({
      next: (response) => {
        // Stocker le token et fermer le dialogue
        this.loginService.storeToken(response.token);
        this.dialogRef.close();

        // Ajouter le fragment à l'URL, puis recharger la page
        window.location.href = `${window.location.origin}/#home`;
        window.location.reload();
      },
      error: () => {
        // Afficher un message d'erreur
        this.errorMessage = 'Nom d’utilisateur ou mot de passe incorrect';
      },
    });
  }


  onClose(): void {
    const dialogElement = document.querySelector('.dialog-container');
    if (dialogElement) {
      dialogElement.classList.remove('open'); // Retirer la classe pour déclencher la fermeture avec animation
    }
    setTimeout(() => {
      this.dialogRef.close(false);
    }, 300); // Attendre la fin de l'animation avant de fermer la popup
  }
}
